<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>การทำงาน</v-toolbar-title>
      <v-divider
        class="mx-2"
        inset
        vertical
      ></v-divider>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-btn slot="activator" color="primary" dark class="mb-2" v-if="hasAccess(allowedRoles)">เพิ่ม</v-btn>
        <v-card>
          <v-card-title>
            <span class="title">{{ formTitle }}</span>
            <v-spacer></v-spacer>
            <v-btn flat icon color="grey" @click="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-text-field v-model="editedItem.year" label="ปี"></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field v-model="editedItem.position" label="ตำแหน่ง"></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field v-model="editedItem.company" label="บริษัท"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="grey white--text" @click="close">ยกเลิก</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="green white--text" @click="save">บันทึก</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="personData.works"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.year }}</td>
        <td class="text-xs-left">{{ props.item.position }}</td>
        <td class="text-xs-left">{{ props.item.company }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
            v-if="hasAccess(allowedRoles)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
            v-if="hasAccess(allowedRoles)"
          >
            delete
          </v-icon>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { hasAccessMixin } from '@/mixins/hasAccessMixin'
import swal from 'sweetalert2'

export default {
  mixins: [ hasAccessMixin ],
  props: [ 'personId' ],
  data: () => ({
    allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE'],
    dialog: false,
    headers: [
      { text: 'ปี', value: 'year' },
      { text: 'ตำแหน่ง', value: 'position' },
      { text: 'บริษัท', value: 'name' },
      { text: 'Actions', value: 'name', sortable: false }
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {

    },
    defaultItem: {
      
    },
    rules: {
      required: (value) => !!value || 'ไม่สามารถเป็นค่าว่าง'
    },
    valid: false
  }),

  computed: {
    ...mapGetters({
      educationLevelItems: 'person/educationLevelItems',
      personData: 'person/personData'
    }),
    formTitle () {
      return this.editedIndex === -1 ? 'เพิ่มรายการ' : 'แก้ไขรายการ'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    
  },

  methods: {
    editItem (item) {
      this.editedIndex = this.personData.works.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.personData.works.indexOf(item)
      swal({
        title: 'คุณแน่ใจ?',
        text: "คุณจะไม่สามารถเรียกคืนข้อมูลได้อีก!",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่, ฉันต้องการลบข้อมูลนี้!'
      }).then((result) => {
        if (result.value) {
          const dispatch = 'person/deleteItem'
          item.dispatch = 'works'
          this.$store.dispatch(dispatch, item)
            .then((response) => {
              setTimeout( ()=> this.$store.dispatch('person/fetchPerson', this.personId), 500)
              this.close()
            }).catch((error)=>{
              console.log('initialize', error)
              swal('เกิดข้อผิดพลาด!', error.message, 'error')
            })
          swal(
            'ลบรายการ!',
            'คุณได้ทำการลบรายการเรียบร้อยแล้ว',
            'success'
          )
        }
      })
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      const dispatch =  this.editedIndex === -1 ? 'person/createItem' : 'person/updateItem'
      this.editedItem.person = this.personId
      this.editedItem.dispatch = 'works'
      this.$store.dispatch(dispatch, this.editedItem)
        .then((response) => {
          swal({
              title: 'Success!',
              type: 'success'
            }).then(response => {
              setTimeout( ()=> this.$store.dispatch('person/fetchPerson', this.personId), 500)
              this.close()
            })
        }).catch((error)=>{
          console.log('error', error)
          swal('Error!', error.message, 'error')
        })
      this.close()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/person/shows/work/index.vue